import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Anexo } from '../../core/models/workflow.models';

@Component({
  selector: 'app-upload-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './upload-list.component.html',
  styleUrl: './upload-list.component.scss',
})
export class UploadListComponent {
  @Input({ required: true }) anexos: Anexo[] = [];
}
